// extracted by mini-css-extract-plugin
module.exports = {"button":"styles_button__2n3g3","list":"styles_list__wavxs"};